import { all, call, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants/index';
import { network } from './network';


export function* getCards() {
  yield call(network, 'card', 'index',
    ActionTypes.PAYMENT_GET_SUCCESS,
    ActionTypes.PAYMENT_GET_FAILURE,
  );
}


export function* addCard({ payload }) {
  yield call(network, 'card', 'add',
    ActionTypes.PAYMENT_ADD_SUCCESS,
    ActionTypes.PAYMENT_ADD_FAILURE,
    { ...payload }
  );
}


export function* makePrimaryCard({ payload }) {
  yield call(network, 'card', 'makePrimary',
    ActionTypes.PAYMENT_PRIMARY_SUCCESS,
    ActionTypes.PAYMENT_PRIMARY_FAILURE,
    { ...payload }
  );
}


export function* deleteCard({ payload }) {
  yield call(network, 'card', 'delete',
    ActionTypes.PAYMENT_DELETE_SUCCESS,
    ActionTypes.PAYMENT_DELETE_FAILURE,
    { ...payload }
  );
}


export default function* root() {
  yield all([
    takeLatest(ActionTypes.PAYMENT_GET_REQUEST, getCards),
    takeLatest(ActionTypes.PAYMENT_ADD_REQUEST, addCard),
    takeLatest(ActionTypes.PAYMENT_PRIMARY_REQUEST, makePrimaryCard),
    takeLatest(ActionTypes.PAYMENT_DELETE_REQUEST, deleteCard),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/payment.js